import { Model } from 'app/model/backendmodel';
import { AdapterRegistry, Column } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { DatabricksDataset } from 'app/model/dataset/databricks.dataset';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { HierarchicalNode } from 'app/model/dataset/hierarchicalnode';
import { NamedArray } from 'app/model/base/namedarray';
import { GlobalVariables } from 'app/services/globals';
import { ValueAdapter } from '../value.adapter';
import { parseAzureDatabricksDeltaLakeSchema } from './azure-databricks-delta-lake-dataset.adapter';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DatabricksDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                catalog: GlobalVariables.enableAzDatabricksCatalog ? '*' : undefined,
                database: '*',
                table: '*'
            }
        }
    }
})
export class DatabricksDatasetAdapter extends TabularTypeDatasetAdapter<DatabricksDataset, Model.DatasetResource> {
    public parseHierarchicalSchema(obj: unknown): HierarchicalNode {
        try {
            return parseAzureDatabricksDeltaLakeSchema(obj);
        } catch {
            return undefined;
        }
    }

    protected async _toResource(dataset: DatabricksDataset): Promise<Model.DatasetResource> {
        const result = await this._toResourceInternal(dataset,
            adfModelTypeMap.databricks.datasetType,
            undefined,
            'database',
            undefined,
            true
        );
        if (GlobalVariables.enableAzDatabricksCatalog) {
            result.properties.typeProperties.catalog = ValueAdapter.toResource(dataset, DatabricksDataset.DATABASE) || undefined;
        }
        result.properties.schema = dataset.rawHierarchicalSchema || [];
        return result;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: DatabricksDataset): Promise<DatabricksDataset> {
        const result = await this._toModelInternal(modelDatasetResource,
            dataset,
            DatabricksDataset.MODEL,
            undefined,
            'database',
            undefined,
            true);
        if (GlobalVariables.enableAzDatabricksCatalog) {
            ValueAdapter.toModel(result, DatabricksDataset.DATABASE, modelDatasetResource.properties.typeProperties?.catalog);
        }
        if (modelDatasetResource.properties.schema && modelDatasetResource.properties.schema.length > 0) {
            result.rawHierarchicalSchema = modelDatasetResource.properties.schema;
            result.schemas = this.parseHierarchicalSchema(result.rawHierarchicalSchema);
            if (result.schemas && result.schemas.children) {
                result.columns = result.schemas.children.map((c) => {
                    const col = new Column();
                    col.name = c.name;
                    col.physicalType = c.columnType;
                    col.columnType = c.columnType;
                    return col;
                }) as NamedArray<Column>;
            } else {
                result.columns = [] as NamedArray<Column>;
            }
        }
        return result;
    }
}
